


















import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { MapGetters } from '@/utils/vuexHelpers';
import UserLogoutModal from './UserLogoutModal.vue';

@Component({
  components: {
    UserLogoutModal
  }
})
@MapGetters('auth', ['user', 'userFullName'])
export default class UserMenu extends Vue {
  logoutModal: any;

  beforeDestroy() {
    if (this.logoutModal && this.logoutModal.close) {
      this.logoutModal.close();
    }
  }

  logOut() {
    this.logoutModal = this.$modal.open({
      parent: this,
      component: UserLogoutModal,
      hasModalCard: true,
      canCancel: false
    });
  }
}
